import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from '../assets/img/Profile.png'
import { ArrowDownCircle } from "react-bootstrap-icons";
import 'animate.css';
import Confetti from 'react-confetti';
import TrackVisibility from 'react-on-screen';
import { redirect } from "react-router-dom";
import Resume from "../assets/doc/Resume.pdf"
import CelebrationAlert from "./celebrationalert/celebrationalert";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const [convit, setconvitity] = useState(false);
  const toRotate = [ " A Full Stack  Developper" ];
  const period = 2000;

  useEffect(() => {
    setconvitity(true)
    setTimeout(()=>{setconvitity(false)},5000)

    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeInUp" : ""}>
                <span className="tagline">Welcome to my Portfolio</span>
                <h1>{`Hi! I'm Hamza`} <span className="txt-rotate" dataPeriod="800" data-rotate='[ "Web Developer", "Web Designer", "UI/UX Designer" ]'><br/><span className="wrap">{text}</span></span></h1>
                  <p>
                  I am Hamza Shaieb, a full-stack web developer with a passion for JavaScript and its libraries,Additionally, I pride myself on my work ethic, motivation, and cooperative nature, which are integral to my success in this field.
                  </p>
                  <a href={Resume} download={Resume} >Resume<ArrowDownCircle color="#2FF3E0" size={30} className="Arrowdown" /></a>
              </div>}
            </TrackVisibility>
          </Col> 
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn  " : ""}>
                  <img src={headerImg} alt="Header Img" loading="lazy" />
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
